import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
} from '@angular/core';

@Component({
  selector: 'paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
})
export class PaginatorComponent implements OnInit {
  @Input() CurrentPage = 1;
  @Input() disableBack: boolean = true;
  @Input() disableForth: boolean = false;

  @Output() goBack = new EventEmitter<void>();
  @Output() goForth = new EventEmitter<void>();

  constructor() {}

  ngOnInit() {}
  previousPage(): void {
    this.goBack.emit();
  }

  nextPage(): void {
    this.goForth.emit();
  }
}
